const ReportsTest = () => import("./views/ReportsTests.vue");
const Report = () => import("./views/Report.vue");
const ReportOverview = () => import("./views/ReportOverview.vue");
const ReportDetail = () => import("./views/ReportDetail.vue");

export const reportRoutes = [
  {
    path: "/report",
    name: "ReportOverview",
    component: ReportOverview,
  },
  {
    path: "/report-detail",
    name: "Report",
    component: Report,
  },
  {
    path: "/report/:reportId",
    name: "ReportDetail",
    component: ReportDetail,
  },
  {
    path: "/report/test",
    name: "ReportTest",
    component: ReportsTest,
  },
];
